// extracted by extract-css-chunks-webpack-plugin
module.exports = {"large":"1025px","medium":"768px","small":"480px","xlarge":"1440px","xsmall":"0","mobileNavigationtransitionduration":"500ms"};